import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from "@angular/router";
import { AppService } from "./app.service";
import { Helpers } from "./helpers";
import { UsuariosService } from "./shared/services/api/usuarios.service";
import { NotificationService } from "./shared/services/socket/notification.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent implements OnInit {
  title = "app";
  notificaciones: any[] = [];
  globalBodyClass =
    'm-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';
  constructor(
    private _router: Router,
    public appService: AppService,
    private notificationService: NotificationService,
    private usuariosService: UsuariosService,
  ) {}

  ngOnInit() {
    Helpers.setLoading(false);
    Helpers.bodyClass(this.globalBodyClass);

    this._router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        // Evita overlay "cargando" pegado en el primer paint (F5 / hard reload).
        if (this._router.navigated) {
          Helpers.setLoading(true);
        }
      }
      if (
        route instanceof NavigationEnd ||
        route instanceof NavigationCancel ||
        route instanceof NavigationError
      ) {
        Helpers.setLoading(false);
        Helpers.bodyClass(this.globalBodyClass);
      }
    });
  }

  getProfile() {
    this.usuariosService.getProfile().subscribe(user => {
      this.appService.user = user.json().data;
    });
  }
}
